

import React from 'react';
import { motion } from 'framer-motion'; // Import motion from framer-motion

// Import your existing components
import BannerSlider from '../components/Banner';
import WellnessCarousel from '../components/Carosoel';
import ProductFilter from '../components/Products';
import Benefits from '../components/Benefits';
import TrustedBrands from '../components/Buy';
import ReviewsSection from '../components/Google';
import Process from '../components/Process';
import VideoGrid from '../components/Video-grid';
import WinnersSlider from '../components/Winner';
import Gallery from '../components/Gallery';
import RecipeSection from '../components/Recipe';
import FAQ from '../components/Faq';
import TrustedBrandsHaro from '../components/Trade';
import { Helmet } from "react-helmet";

// Define different animation variants for sections
// Each variant describes an initial 'hidden' state and a 'visible' (animated) state.

// Fade in from bottom (default)
const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

// Fade in from left
const fadeInLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

// Fade in from right
const fadeInRight = {
  hidden: { opacity: 0, x: 100 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

// Zoom in from small scale
const zoomIn = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

// Rotate and fade in
const rotateIn = {
  hidden: { opacity: 0, rotate: -15, y: 50 },
  visible: {
    opacity: 1,
    rotate: 0,
    y: 0,
    transition: {
      duration: 0.9,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

export default function HomePage() {

  return (
    // The main container for the home page, with overflow-hidden to prevent horizontal scroll during slide-in animations


    <>
      <Helmet>
        <title>Haronics</title>
        <meta name="description"
          content="Buy premium quality cold pressed oils from Haronics. 100% pure, traditional wooden ghani oils." />

        <meta
          name="keywords"
          content="Haronics cold pressed oils, Haronics wooden ghani oils, Haronics chemical-free cooking oil, Haronics coconut oil, Haronics edible oils India"
        />
      </Helmet>
      <div className="overflow-hidden">

        <motion.section
          variants={fadeInUp} // Using fadeInUp
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <BannerSlider />
        </motion.section>

        <motion.section
          variants={rotateIn} // Using rotateIn
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <WellnessCarousel />

        </motion.section>

        <motion.section

        >
          <ProductFilter />
        </motion.section>
        {/* <HaronicsProfile /> */}

        <motion.section
          variants={fadeInRight} // Using fadeInRight
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <Benefits />
        </motion.section>

        <motion.section
          variants={fadeInUp} // Reusing fadeInUp
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <WinnersSlider />
        </motion.section>

        <motion.section
          variants={zoomIn} // Reusing zoomIn
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <TrustedBrands />
        </motion.section>

        <motion.section
          variants={fadeInLeft} // Reusing fadeInLeft
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <Process />
        </motion.section>

        <motion.section
          variants={fadeInRight} // Reusing fadeInRight
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <RecipeSection />
        </motion.section>



        <motion.section
          variants={rotateIn} // Using rotateIn
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >

          <Gallery />
        </motion.section>

        <motion.section
          variants={fadeInUp} // Reusing fadeInUp
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <TrustedBrandsHaro />
        </motion.section>

        <motion.section
          variants={fadeInLeft} // Reusing fadeInLeft
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <VideoGrid />
        </motion.section>

        <motion.section
          variants={zoomIn} // Reusing zoomIn
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <ReviewsSection />
        </motion.section>

        <motion.section
          variants={fadeInRight} // Reusing fadeInRight
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }} // Adjusted amount for mobile
          className="py-12 md:py-16 lg:py-20"
        >
          <FAQ />
        </motion.section>
      </div>
    </>

  );
}
